<mat-paginator
  class="ac-table-paginator"
  (page)="handlePageEvent($event)"
  [pageSize]="pageSize$ | async"
  [pageIndex]="page$ | async"
  [length]="count$ | async"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="'true'"
  aria-label="Select page"
></mat-paginator>
